import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isAdminUser } from 'models/user-management/helpers/admin-check';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { toasterOptions } from 'models/shared/enums/toaster.enum';

interface RequireAdminProps {
	children: JSX.Element;
}

function RequireAdmin({ children }: RequireAdminProps) {
	const isAdmin = isAdminUser();

	useEffect(() => {
		if (!isAdmin) {
			toasterNotification({
				msg: 'Access denied. Only ADMIN users can access this page.',
				toasterType: toasterOptions.error,
			});
		}
	}, [isAdmin]);

	if (!isAdmin) {
		return <Navigate to="/assets" replace />;
	}

	return children;
}

export default RequireAdmin;
